import { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faCalendarXmark,
    faCommentQuestion,
    faFileCircleCheck,
    faPhoneVolume,
    faBadgePercent,
    faUserClock
} from '@fortawesome/pro-light-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import styles from './LeadsActivation.module.scss';

export interface Props {
    isSaving: boolean;
    onActivate: () => void;
}

interface Feature {
    icon: IconDefinition;
    label: string;
}

const features: Array<Feature> = [
    { icon: faCalendarXmark, label: 'Abandoned Booking Leads' },
    { icon: faCommentQuestion, label: 'Unknown SMS Contacts' },
    { icon: faFileCircleCheck, label: 'Intake Form Submissions' },
    { icon: faPhoneVolume, label: 'Walk-ins and Phone Leads' },
    { icon: faBadgePercent, label: 'New Client Promotions' },
    { icon: faUserClock, label: 'Prospect Follow-ups' }
];

const LeadsActivation: FunctionComponent<Props> = ({ isSaving, onActivate }) => {
    return (
        <div className={styles.card}>
            <div className={styles.imageColumn}>
                <img
                    className={styles.image}
                    src="/images/leads/leads-activation.jpg"
                    alt="Grow your client base with Leads"
                />
            </div>

            <div className={styles.content}>
                <h2 className={styles.title}>Grow your client base with Leads.</h2>

                <p className={styles.subtitle}>
                    Capture prospects, organize follow-ups, and turn interest into real clients. Try tracking:
                </p>

                <ul className={styles.featureList}>
                    {features.map(feature => (
                        <li
                            key={feature.label}
                            className={styles.featureItem}
                        >
                            <FontAwesomeIcon
                                icon={feature.icon}
                                className={styles.featureIcon}
                            />
                            <span className={styles.featureLabel}>{feature.label}</span>
                        </li>
                    ))}
                </ul>

                <p className={styles.footnote}>
                    Track the full prospect-to-client journey - from first contact to first completed service, sale, or
                    paid membership.
                </p>

                <Button
                    label="Activate Lead Tracking"
                    variant="primary"
                    size="small"
                    isLoading={isSaving}
                    onClick={onActivate}
                    className={styles.activateButton}
                />
            </div>
        </div>
    );
};

export default LeadsActivation;
